"use client";

import { useState, useEffect } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { useLanguage } from "@/context/language-context";
export function Preloader() {
  const [isLoading, setIsLoading] = useState(true);
  const { language } = useLanguage();
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    setIsLoading(true);

    const lockScroll = () => {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    };

    const unlockScroll = () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };

    lockScroll();

    const timer = setTimeout(() => {
      setIsLoading(false);
      unlockScroll();
    }, 1200);

    return () => {
      clearTimeout(timer);
      unlockScroll();
    };
  }, [language]);

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          key="preloader"
          initial={{ y: 0 }}
          exit={{
            y: "-100%",
            transition: { duration: 0.9, ease: [0.76, 0, 0.24, 1] },
          }}
          className="pointer-events-auto fixed inset-0 z-preloader flex flex-col items-center justify-center bg-background"
        >
          <motion.div
            initial={reducedMotion ? { opacity: 1 } : { opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={
              reducedMotion
                ? { opacity: 0 }
                : { opacity: 0, scale: 0.9, transition: { duration: 0.4 } }
            }
            transition={{ duration: reducedMotion ? 0.2 : 0.6, ease: "easeOut" }}
            className="relative z-10 flex flex-col items-center gap-8"
          >
            <div className="relative flex h-36 w-36 items-center justify-center">
              <motion.svg
                animate={reducedMotion ? undefined : { rotate: 360 }}
                transition={{ duration: 12, ease: "linear", repeat: Infinity }}
                viewBox="0 0 100 100"
                className="absolute inset-0 h-full w-full opacity-40"
              >
                <circle
                  cx="50"
                  cy="50"
                  r="48"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="0.5"
                  strokeDasharray="2 6"
                  className="text-muted-foreground"
                />
              </motion.svg>

              <motion.svg
                viewBox="0 0 100 100"
                className="absolute inset-0 h-full w-full -rotate-90"
              >
                <circle
                  cx="50"
                  cy="50"
                  r="46"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1"
                  className="text-border/30"
                />
                <motion.circle
                  cx="50"
                  cy="50"
                  r="46"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeDasharray="289"
                  initial={{ strokeDashoffset: 289 }}
                  animate={{ strokeDashoffset: 0 }}
                  transition={{ duration: 2, ease: [0.65, 0, 0.35, 1] }}
                  className="text-primary"
                />
              </motion.svg>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
